import app from "@/app";
import { BranchSelect, TreeSelect } from "./tree";
import { SingleTreeSelectController } from "./single-tree-select-controller";
import { MultiTreeSelectController } from "./multi-tree-select-controller";

app.register('tree-select', TreeSelect);
app.register('branch-select', BranchSelect);
app.register('single-tree-select', SingleTreeSelectController);
app.register('multi-tree-select', MultiTreeSelectController);